<template>
  <div
    v-trap-focus
    v-auto-focus
    :aria-label="ariaLabel"
    tabindex="0"
    aria-modal="true"
    role="dialog"
    class="focus-invisible"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    ariaLabel: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss"></style>
